var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex pa-10 grey--text fill-height flex-column justify-center align-center"},[_c('div',{staticClass:"text-center"},[_vm._v("Access denied.")]),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.ip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }